export class WFSpecialHandlingParametersDto {
    specialHandlingId: number;
    specialInstruction: string;
    workflowId: number;
    communityId: number;
}
